import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { GetAChannel } from "../../stores/GetAChannel";
import {
  Paper,
  Title,
  Text,
  Button,
  Loader,
  Stack,
  Center,
  Alert,
  Anchor,
} from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";

const OrderStatus: React.FC<{ getAChannel: GetAChannel }> = observer(
  ({ getAChannel }) => {
    useEffect(() => {
      getAChannel.pollOrderStatus();
    }, []);

    return (
      <>
        {getAChannel.pollingStatus === "polling" && (
          <Stack>
            <Text mt="md">Waiting up to fifteen minutes for payment...</Text>
            <Center>
              <Loader />
            </Center>
            <Alert
              variant="light"
              color="blue"
              title="I tried paying the invoice... but the payment failed!"
              icon={<IconInfoCircle />}
            >
              <Stack>
                <Text>
                  If you find that the invoice payment failed, it's often
                  because we tried to open a channel to your node, but the
                  channel opening failed for some reason... and then your
                  payment was rejected.
                </Text>
                <Text>
                  Usually this because something is unusual with your Node's
                  configuration...
                </Text>
                <Text>
                  We want to help! Please{" "}
                  <Anchor href="/contact" target="_blank">
                    contact us on Signal or Telegram
                  </Anchor>
                  .
                </Text>
              </Stack>
            </Alert>
          </Stack>
        )}
        {getAChannel.pollingStatus === "completed" && (
          <Text mt="md"> ✅ Success! Your channel is opening. </Text>
        )}
        {getAChannel.pollingStatus === "timeout" && (
          <Stack>
            <Text mt="md">Polling timed out after 15 minutes.</Text>
            <Button
              onClick={() => getAChannel.resetGetAChannelToDefaultValues()}
              mt="md"
            >
              Start Over
            </Button>
          </Stack>
        )}
      </>
    );
  }
);

export default OrderStatus;
